export const jwtParse = jwt => {
    if (jwt && jwt.indexOf('.') !== -1) {
        return JSON.parse(
            window.decodeURIComponent(
                Array.prototype.map
                    .call(
                        atob(jwt.split('.')[1].replace('-', '+').replace('_', '/')),
                        c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
                    )
                    .join('')
            )
        );
    }
    return {
        cnpj: '',
        sid: '',
        unique_name: '',
        nameid: '',
        email: '',
        status: '',
        idGrupo: '',
        idUserHub: '',
        nomeGrupo: '',
        utilizaCrmTerceiro: '',
        statusPolicy: '',
        isUserHub: '',
        nomeFantasia: '',
        tenant: '',
        role: '',
        permissions: [],
        produtos: [],
    };
};
export const cookieGet = key => {
    let cookie;
    const value = `; ${window.document.cookie}`;
    const parts = value.split(`; ${key}=`);
    if (parts.length === 2) {
        cookie = parts.pop().split(';').shift();
    }
    return cookie;
};
export const jwtGet = (cookieName = false) => {
    if (cookieName) {
        const jwtNamed = cookieGet(cookieName);
        return jwtParse(jwtNamed);
    }
    const jwt = cookieGet('CockpitLogged') || cookieGet('AppLogged');
    return jwtParse(jwt);
};
const objAdobeTrackingDefault = () => ({
    site: {
        domain: window.location.hostname, /* [Verificar com Arquitetura, Com API de terceiros] // Armazena o domínio do website. */
        country: undefined, /* [Verificar com Arquitetura, Com API de terceiros] Armazena o país do website. */
        server: "web", /* Armazena o servidor da aplicação. */
        environment: 'cockpit', /* Armazena o ambiente do website */
        tmsVersion: undefined, /* [Verificar com Arquitetura | Valor de deploy] // Armazena o número da versão do tms. */
        clientType: 'pj', /* Armazena o tipo de pessoa para qual o website foi construído. */
        platform: (/(android|bb\d+|meego|avantgo|bada|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|iphone|ipod|iris|kindle|lge|maemo|midp|mmp|mobile.*firefox|netfront|opera.*mobi|palm|phone|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino)/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent || navigator.vendor || window.opera.substr(0, 4))) ? 'mobile' : 'desktop', /* Armazena o tipo de dispositivo do website.('desktop' ou 'mobile') */
    },
    page: {
        status: 200, /* Armazena o tipo de status code do evento. */
        url: window.location.href, /* Armazena a URL da página. */
        loadTime: window.performance.PerformanceNavigationTiming, /* [CONFIRMAR SE ESTÁ EM SEGUNDOS] // Tempo de carregamento da página em segundo */
        trackingCode: {
            idcmp: undefined, /* Armazena o parâmetro dentro da query string "&idcmp". Ex: 's2:c2:sdadga87std812' */
            idcmpint: undefined, /* Armazena o parâmetro dentro da query string "&idcmpint". Ex: 's2:c4:iusdagiudhsaod' */
            icid: undefined, /* Armazena o parâmetro dentro da query string "&icid". */
            lkid: undefined, /* Armazena o parâmetro dentro da query string "&lkid". */
        },
        interaction: undefined, /* Armazena o tipo de interação do evento. */
        cdn: {
            message: undefined, /* Armazena a mensagem do erro. */
        }
    },
    products: {
        dealer: {
            totalItems: undefined, /* Armazena o total de produtos */
            totalPrice: undefined, /*  Armazena o preço total */
            items: [
                {
                    sku: undefined, /* Armazena id od produto */
                    name: undefined, /* Armazena nome do produto */
                    feirao: undefined, /* Armazena o nome do feirão */
                    regiao: undefined, /* Armazena região escolhida na compra */
                    plano: undefined, /* Armazena plano escolhida na compra */
                    duracao: undefined, /* Armazena duração escolhida na compra */
                },
            ],
        },
    },
    user: {
        loginStatus: undefined, /* "logado = 1" ou "nao logado = 2" */
        cockpitUserId: undefined, /* Armanena o código do cliente cadastrado. */
        clientId: undefined, /* Armanena o código do dealer cadastrado. */
        typeId: undefined, /* Armazena os diferentes tipos de usuários/acessos caso exista. */
        cnpj: undefined, /* Armazena os diferentes tipos de usuários/acessos caso exista. */
    },
});
const dispatchEventTagManager = e => console.log(`${e.type}: ${window.objDataLayer.page.pageName}`);
export default (event = 'customPageView', dataLayer = {}, cdnMessage = '') => {
    const { objDataLayer } = window;
    const objAdobeTracking = (objDataLayer && objDataLayer.site ? { ...objDataLayer } : objAdobeTrackingDefault());

    const {
        sid,
        unique_name,
        role,
        cnpj
    } = jwtGet();
    const statusLogged = {
        logged: 1,
        noLogged: 2,
    };

    Object.entries(dataLayer).forEach((item) => {
        const [key, value] = item;
        objAdobeTracking[key] = { ...objAdobeTracking[key], ...value };
    });

    const { site, user, page } = objAdobeTracking;

    site.country = window?.env?.i18n?.country?.toLowerCase() || dataLayer?.site?.country?.toLowerCase() || '';

    user.loginStatus = (sid !== '' ? statusLogged.logged : statusLogged.noLogged);
    user.cockpitUserId = sid;
    user.clientId = unique_name;
    user.typeId = (typeof role === 'object' ? [...role] : [role]);
    user.cnpj = cnpj;

    if (!page.trackingCode) {
        page.trackingCode = {};
    }

    const params = window.location.search

    const searchParams = new URLSearchParams(params);

    page.trackingCode.idcmp = searchParams.get('idcmp');
    page.trackingCode.idcmpint = searchParams.get('idcmpint');
    page.trackingCode.icid = searchParams.get('icid');
    page.trackingCode.lkid = searchParams.get('lkid');
    page.interaction = event
    page.cdn = {
        message: cdnMessage
    };
    window.objDataLayer = objAdobeTracking;

    document.addEventListener(event, dispatchEventTagManager);
    document.addEventListener('userInteraction', dispatchEventTagManager);
    document.dispatchEvent(new CustomEvent(event, { detail: objAdobeTracking }));
    if(event != 'customPageView' && event != 'cdnNotification') document.dispatchEvent(new CustomEvent('userInteraction', { detail: objAdobeTracking }));

    document.removeEventListener(event, dispatchEventTagManager);
    document.removeEventListener('userInteraction', dispatchEventTagManager);
};